import React from 'react';
import { connect } from 'react-redux';

import Login from '../../../../../containers/forms/login/Login';


function CompIdentification(props) {

  const { previous,next } = props.navigation;
  return (
    <div>
      <div><Login/></div>
      <div>
        <button onClick={previous}>Anterior</button>
        <button onClick={next} disabled={
          (()=>{
            return false;
            /* 
            if(props.user && props.user.idusuario){
              return false;
            }
            return true;
 */
          })()
        }>Próximo</button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes,    
    pendingTasks: state.pendingTasks,
    user: state.loginValidaReducer
  };
}
export default connect(mapStateToProps)(CompIdentification);
